export var EmailTemplateType;
(function (EmailTemplateType) {
    EmailTemplateType["custom"] = "Custom";
    EmailTemplateType["sendReviewLetter"] = "Send Completed Review Letter";
    EmailTemplateType["sendCarFaxReport"] = "Send Car Fax Report";
    EmailTemplateType["billingNotification"] = "Send to TTI Billing";
})(EmailTemplateType || (EmailTemplateType = {}));
